export default __webpack_public_path__ + "media/images/settings_128-c8fdb12cad03c0523b8cafd315dff954.png";